import { useMutation } from '@tanstack/react-query';
import { bulkOnApprovalBankOperation } from 'config/requests/bankOperations';
import { queryClient } from 'providers/queryClient';

export function useBulkOnApprovalRequestsBankOps() {
  const mutation = useMutation({
    mutationFn: ({ ids }: { ids: number[] }) => bulkOnApprovalBankOperation(ids),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['bank_operations/pending_statuses'] });
    },
  });

  return { bulkOnApprovalRequestsBankOps: mutation };
}
